import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export enum TipoAlerta {
  Exito = 'success',
  Info = 'info',
  Precaucion = 'warning',
  Error = 'error'
}

@Injectable()
export class AlertaService {

  constructor(private messageService: MessageService) { }

  /**
 * Muestra una alerta flotante
 * @param tipo
 * @param mensaje
 * @param fijo Si el valor en true la alerta se mostrará hasta dar clic en la X
 */
  mostrar(tipo: TipoAlerta, summary: string, mensaje: string, fijo?: boolean) {
    this.limpiarAlertas();
    let severity = '';
    switch (tipo) {
      case TipoAlerta.Exito: severity = 'success'; break;
      case TipoAlerta.Info: severity = 'info'; break;
      case TipoAlerta.Precaucion: severity = 'warn'; break;
      case TipoAlerta.Error: severity = 'error'; break;
      default: severity = 'info'; break;
    }
    this.messageService.add({ severity, summary, detail: mensaje, sticky: !!fijo });
  }

  limpiarAlertas() {
    this.messageService.clear();
  }

  mostrarMultiple(tipo: TipoAlerta, summary: string, mensaje: string, fijo?: boolean) {
    let severity: string = '';
    switch (tipo) {
      case TipoAlerta.Exito: severity = 'success'; break;
      case TipoAlerta.Info: severity = 'info'; break;
      case TipoAlerta.Precaucion: severity = 'warn'; break;
      case TipoAlerta.Error: severity = 'error'; break;
      default: severity = 'info'; break;
    }
    this.messageService.add({ severity, summary, detail: mensaje, sticky: !!fijo });
  }
}
